import { useAuthQuery } from '@/api/index.ts';
import { SAMPLES_ALLOWED_ROLES } from '@/config/samples';
import { useAppStore } from '@/stores/app';
import { hasOrgRole } from '@helpers/roles';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

// Called once per table, not per cell: the answer is identical for every row, and a subscription
// per cell would re-render the whole column on each tab-focus auth revalidation.
export function useCanOpenSampleDetail(): boolean {
  const { data: currentUser, isPending, isError } = useAuthQuery();
  const orgId = useAppStore(useShallow(state => (state.selectedOrganization ?? state.selectedOrgStub)?.id));

  // Logged from an effect, not render, so StrictMode's double-invoke doesn't double-emit it.
  useEffect(() => {
    if (isError) console.error('[useCanOpenSampleDetail] auth query failed; treating as unresolved, not denied');
  }, [isError]);

  // Unresolved is "not known yet", not "denied" — the route guard fails closed either way.
  // `currentUser == null` also covers a 401, which useAuthQuery resolves as data:null, not isError.
  if (isPending || isError || currentUser === null || currentUser === undefined || orgId === undefined) return true;

  return SAMPLES_ALLOWED_ROLES.some(role => hasOrgRole(currentUser?.assumed_roles, orgId, role));
}
